export function findAssignedSchool(schools, schoolId) {
  if (!schoolId || !Array.isArray(schools)) return null;
  return schools.find((school) => school.uuid === schoolId || school.ncessch === schoolId) || null;
}
